import { ROUTE } from '@lib/core/const';
import { PERMISSION } from '@lib/core/enum';
import { Permission, Uuid } from '@lib/core/type';
import { LinkSource } from '@proget-shared/ui/link';

export class Ldap implements LinkSource {
  constructor(
    public readonly id: Uuid,
    public readonly name: string
  ) {}

  getRouterLink(): string[] {
    return [ROUTE.BASE, ROUTE.SETTINGS.BASE, ROUTE.SETTINGS.LDAP.BASE, this.id.toString(), ROUTE.SETTINGS.LDAP.EDIT];
  }

  getDisplayName(): string {
    return this.name;
  }

  getLinkPermission(): Permission {
    return PERMISSION.ALLOW_ADD_LDAP_CONNECTION;
  }
}
